import { motion } from 'framer-motion';
import styled from 'styled-components';

type TooltipVariant = 'light' | 'dark';

interface StyledTooltipProps {
  $variant: TooltipVariant;
  $multiline: boolean;
  $maxWidth?: number;
  background?: string;
  border?: string;
  zoom: number;
}

export const StyledTooltip = styled(motion.div)<StyledTooltipProps>`
  white-space: ${({ $multiline }) => ($multiline ? 'pre-wrap' : 'nowrap')};
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-color: ${({ background, $variant, theme }) =>
    background ||
    ($variant === 'dark' ? theme.color.pickledBluewood : theme.color.white)};
  color: ${({ $variant, theme }) =>
    $variant === 'dark' ? theme.color.white : theme.color.baliHai};
  border: ${({ border, $variant, theme }) =>
    border ||
    ($variant === 'dark' ? 'none' : `1px solid ${theme.color.porcelain}`)};
  border-radius: ${({ zoom }) => 12 * zoom}px;
  z-index: 1000000000000;
  padding: ${({ zoom }) => `${10 * zoom}px ${16 * zoom}px`};
  text-align: center;
  font-size: ${({ zoom }) => 12 * zoom}px;
  font-weight: 600;
  line-height: ${({ zoom }) => 15 * zoom}px;
  box-shadow: 0 5px 15px ${({ theme }) => theme.color.dimmer};
  max-width: ${({ $maxWidth, zoom }) =>
    $maxWidth ? `${$maxWidth * zoom}px` : 'none'};
`;
